import { Avatar, Chip, ListItemAvatar, ListItemButton, ListItemText, Typography } from "@mui/material";
import { MainListItem } from "components/theme/buttons/main.list.item";
import { LinkProps } from "react-router-dom";

type Props = {
    title: string;
    selected: boolean;
    avatarUrl?: string;
    avatarSubstitute?: string;
    subtitle?: string;
    chips?: Array<{color: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" | undefined, label: string}>;
    component?: React.ForwardRefExoticComponent<LinkProps & React.RefAttributes<HTMLAnchorElement>>;
    to?: string;
};

const ListCard = ({title, avatarUrl, avatarSubstitute, selected, subtitle, chips, component, to}: Props) => {
    return (
        <MainListItem component={component} to={to} disablePadding sx={{boxShadow: 2}}>
            <ListItemButton selected={selected}>
                {(avatarUrl || avatarSubstitute) && (<ListItemAvatar>
                    <Avatar src={avatarUrl} sx={{ width: 32, height: 32, backgroundColor: 'divider' }}>{!avatarUrl && avatarSubstitute}</Avatar>
                </ListItemAvatar>)}
                <ListItemText
                    primary={
                        <>
                            <Typography component='p' variant='body2' noWrap>{title}</Typography>
                            {subtitle && (<Typography component='p' variant='subtitle1'>{subtitle}</Typography>)}
                        </>
                    }
                    secondary={chips && (
                        <>
                            { chips.map((chip, index) => <Chip key={index} label={chip.label} color={chip.color} component='span'/>)}
                        </>
                    )}
                    secondaryTypographyProps={{component:'div', sx:{mt: '0.5rem', display: 'flex', gap: '0.5rem'} }}
                />
            </ListItemButton>
        </MainListItem>
    );
};

export { ListCard };